import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, str2arr, stringAvatar} from "@/helper/method";
import {ProTable} from "@/widget/ProTable/ProTable";
import {WriteTask} from "@/pages/Task/WriteTask";
import {TaskPageVO, useQueryTaskPage} from "@/service/task.s";
import {Avatar, AvatarGroup} from "@mui/material";
import Chip from "@mui/material/Chip";
import {ViewTask} from "@/pages/Task/ViewTask";
import {assign} from "lodash";
import {AuthButtonVO} from "@/service/menu.s";
import {WriteReport} from "@/pages/Report/WriteReport";
import {WriteWorktime} from "@/pages/Worktime/WriteWorktime";
import {WriteAccepting} from "@/pages/Accepting/WriteAccepting";

export const TaskListPage = () => {
        const {
            mutate: taskPageMutate,
            data: taskPageData,
            isPending: taskPagePending,
        } = useQueryTaskPage()

        const columns: GridColDef<TaskPageVO>[] = [
            {field: "taskName", headerName: "任务名称", flex: 0.5,},
            {
                field: "virtue",
                headerName: "任务属性",
                headerAlign: "center",
                align: "center",
                renderCell: ({row: {virtue, virtueId}}) => {
                    let style = {}
                    if (virtueId == 1) {
                        style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#eb5050 !important', border: 'none'};
                    } else if (virtueId == 2) {
                        style = {"& .MuiChip-label": {color: '#fff'}, backgroundColor: '#f0a800 !important', border: 'none'};
                    }
                    return <Chip label={virtue} variant={'filled'} size={'small'} sx={style}/>
                }
            },
            {field: "planName", headerName: "所属目标", flex: 0.3,},
            {
                field: "priority",
                headerName: "优先级",
                headerAlign: "center",
                align: "center",
                renderCell: ({row: {priority, priorityId}}) => {
                    let style = {}
                    if (priorityId == 1) {
                        style = {backgroundColor: '#fa5353 !important', border: 'none'};
                    } else if (priorityId == 2) {
                        style = {backgroundColor: '#ff9d8d !important', border: 'none'};
                    } else if (priorityId == 3) {
                        style = {backgroundColor: '#f5c13c !important', border: 'none'};
                    } else if (priorityId == 4) {
                        style = {backgroundColor: '#3f8cff !important', border: 'none'};
                    } else if (priorityId == 5) {
                        style = {backgroundColor: '#2fcd6e !important', border: 'none'};
                    }
                    return <Chip label={priority} variant={'filled'} size={'small'} sx={assign(style, {"& .MuiChip-label": {color: '#fff'}})}/>
                }
            },
            {
                field: "startTime",
                headerName:
                    "起止时间",
                flex: 0.5,
                headerAlign:
                    "center",
                align:
                    "center",
                renderCell:
                    ({row: {startTime, endTime}}) => {
                        return `${formatTime("h", startTime)}至${formatTime("h", endTime)}`
                    },
            },
            {
                field: "status",
                headerName: "任务状态",
                headerAlign: "center",
                align: "center",
                renderCell: ({row: {status, statusId}}) => {
                    let style = {}
                    if (statusId == 1) {
                        style = {"& .MuiChip-label": {color: '#ff6692'}, backgroundColor: '#ffecf2 !important', border: 'none'};
                    } else if (statusId == 2) {
                        style = {"& .MuiChip-label": {color: '#00ceb6'}, backgroundColor: '#e0f9f6 !important', border: 'none'};
                    } else if (statusId == 3) {
                        style = {"& .MuiChip-label": {color: '#ffae1f'}, backgroundColor: '#fff5e4 !important', border: 'none'};
                    }
                    return <Chip label={status} variant={'filled'} size={'small'} sx={style}/>
                }
            },
            {
                field: "duration",
                headerName:
                    "预计工时",
                headerAlign:
                    "center",
                align:
                    "center",
            },
            {
                field: "executors",
                headerName: "执行人",
                flex: 0.4,
                headerAlign: "center",
                align: "center",
                display: "flex",
                renderCell: (({row: {executors}}) => {
                    const newExecutors: string[] = str2arr(executors, 'string')
                    return <AvatarGroup sx={{
                        '& .MuiAvatarGroup-avatar': {
                            width: 32, height: 32, fontSize: 10, border: 'none'
                        }
                    }} max={3}>
                        {newExecutors?.map((owner: string, index: number) => <Avatar key={index} {...stringAvatar(owner)} />)}
                    </AvatarGroup>
                })
            },
            {
                field: "createdAt",
                headerName:
                    "登记时间",
                headerAlign:
                    "right",
                align:
                    "right",
                valueFormatter:
                    (value) => formatTime("D", value),
            },
        ]

        return (
            <ProTable<TaskPageVO>
                loading={taskPagePending}
                verifyBtns={(row: TaskPageVO, btns: AuthButtonVO[]) => {
                    const disabled = row.statusId === 3
                    return btns.map((btn) => {
                        if (btn.alias == 'subtask') {
                            return {...btn, disabled: row.virtueId == 2 || disabled, body: <WriteTask subtask={true}/>}
                        } else if (btn.alias == 'report') {
                            return {...btn, disabled, body: <WriteReport fromTask={true}/>}
                        } else if (btn.alias == "worktime") {
                            return {...btn, disabled, body: <WriteWorktime fromTask={true}/>}
                        } else if (btn.alias == 'accepting') {
                            return {...btn, disabled, body: <WriteAccepting mode={'drawer'} fromTask={true}/>}
                        } else if (row.statusId === 3) {
                            return {...btn, disabled: true}
                        }
                        return btn
                    })
                }}
                renderDrawer={{view: <ViewTask mode={'drawer'}/>, write: <WriteTask/>}}
                columns={columns}
                data={taskPageData?.data}
                onSearch={(params) => {
                    taskPageMutate(params);
                }}
                code={"task"}
            />
        );
    }
;
